import React from 'react';
import {ResultItem} from "../../../types/Search";
import ObjectDetails from "../../object/ObjectDetails";
import {Link} from 'react-router-dom';
import {Card} from 'react-bootstrap';
import IconButton from "../../buttons/icon-button/IconButton";
import {CSSTransition} from 'react-transition-group';
import {getObjectViewPageUrl} from "../../../pages/object/ObjectViewPage";

import "./SearchObjectDetails.scss";

type SearchObjectDetailsProps = {
  selectedObject: ResultItem;
  onClose: () => void;
};

/**
 * Component for rendering object properties in a popup panel.
 */
class SearchObjectDetails extends React.Component<SearchObjectDetailsProps> {

  render() {
    const {id, name, type} = this.props.selectedObject;
    const linkTo = getObjectViewPageUrl(id);
    return (
      <div className="SearchObjectDetailsWrapper">
        <CSSTransition timeout={0} classNames="slide" in={true} appear={true} unmountOnExit>
          <Card className="SearchObjectDetails box-shadow">
            <Card.Title>
              <h2>
                <Link to={linkTo} target="_blank">
                  {name || id}
                </Link>
              </h2>
              <IconButton className="close-button" icon="times" onClick={this.props.onClose}/>
            </Card.Title>
            <Card.Body className="SearchObjectDetailsBody border-top">
              <ObjectDetails id={id} type={type} renderTitle={false} forceNewTabs={true}/>
            </Card.Body>
          </Card>
        </CSSTransition>
      </div>
    );
  }
}

export default SearchObjectDetails;
